BaseModel = require './base_model.coffee'

class global.VoipMonthlyPlan extends BaseModel
  @ATTRIBUTES = {
    id: {}
    consumed: {}
    additional_consumed: {}
    max_duration: {}
  }

  @SERIALIZABLE_ATTRIBUTES = ['id', 'consumed', 'additional_consumed', 'max_duration']

  max_duration_in_minutes: ->
    parseInt((@max_duration || 0) / 60)

  consumed_in_minutes: ->
    parseInt((@consumed || 0) / 60)



// WEBPACK FOOTER //
// ./src/models/voip_monthly_plan.coffee